import { Modal, ModalBody, ModalHeader, Form } from 'reactstrap'
import { IconBubbleText, IconX } from '@tabler/icons-react'
import AliFeedbackForm from './AliFeedbackForm'

interface AliFeedbackModalProps {
  isOpen: boolean
  toggle: () => void
}

const AliFeedbackModal: React.FC<AliFeedbackModalProps> = ({ isOpen, toggle }) => {
  return (
    <Modal isOpen={isOpen} toggle={toggle} centered>
      <ModalHeader
        className="!justify-between [&_.custom-close-btn]:!absolute [&_.custom-close-btn]:!top-1 [&_.custom-close-btn]:!right-4 [&_.custom-close-btn_div]:m-auto [&_.custom-close-btn_svg]:!stroke-[color:var(--icon-muted)] [&_.custom-close-btn_span]:!invisible [&_.btn-close]:!hidden"
        toggle={toggle}
        close={
          <IconX
            size={24}
            color="var(--icon-muted)"
            onClick={toggle}
            className="cursor-pointer"
            data-testid="closeBtn"
          />
        }>
        <div className="flex items-center">
          <IconBubbleText size={20} className="me-1" />
          Feedback
        </div>
      </ModalHeader>
      <Form>
        <ModalBody className="p-0 bg-[color:var(--surface-bg)] min-h-[450px] mb-4">
          <AliFeedbackForm toggle={toggle} />
        </ModalBody>
      </Form>
    </Modal>
  )
}

export default AliFeedbackModal
